import { SelectionModel } from '@angular/cdk/collections';

export class SpxSelectionModel<T> extends SelectionModel<T> {
  public hasMultipleValues(): boolean {
    return this.selected?.length > 1;
  }
}
